export const BASE_URL = 'https://gymwyse.the-algo.com/api/v1'

export const AdClinIQAPIUrl = 'https://cliniq.the-algo.com';
